import { applyProposalSteps } from "@productlane/lib/src/prosemirror-diff"

export interface DocsProposalPreview {
	proposalId: string
	kind: "CREATE" | "EDIT" | "DELETE"
	title: string
	icon: string
	baseHtml: string
	// Null when the staged steps no longer apply to their base version, so the
	// card falls back to the review screen instead of rendering a wrong body.
	mergedHtml: string | null
}

export interface GroupProposalContent {
	id: string
	kind: "CREATE" | "EDIT" | "DELETE"
	status: string
	proposedTitle?: string | null
	proposedSteps?: unknown
	article?: { title?: string | null; icon?: string | null } | null
	baseVersion?: { content?: unknown } | null
}

const DEFAULT_ICON = "Page2"

const asHtml = (value: unknown) => (typeof value === "string" ? value : "")

// A DELETE proposal carries no steps, so its "after" is the empty document:
// the diff then reads as the whole article coming out.
function mergedHtmlFor(proposal: GroupProposalContent, baseHtml: string) {
	if (proposal.kind === "DELETE") return ""
	const steps = Array.isArray(proposal.proposedSteps)
		? proposal.proposedSteps
		: []
	try {
		return applyProposalSteps(baseHtml, steps).html
	} catch {
		return null
	}
}

export function docsProposalPreviews(
	proposals: readonly GroupProposalContent[],
): Map<string, DocsProposalPreview> {
	const previews = new Map<string, DocsProposalPreview>()
	for (const proposal of proposals) {
		if (proposal.status !== "OPEN") continue
		const baseHtml = asHtml(proposal.baseVersion?.content)
		previews.set(proposal.id, {
			proposalId: proposal.id,
			kind: proposal.kind,
			title: proposal.proposedTitle ?? proposal.article?.title ?? "Untitled",
			icon: proposal.article?.icon ?? DEFAULT_ICON,
			baseHtml,
			mergedHtml: mergedHtmlFor(proposal, baseHtml),
		})
	}
	return previews
}
